import type { BytemdPlugin } from 'bytemd';

/** 预览/详情中的链接在新标签页打开 */
export function linkTargetBlank(): BytemdPlugin {
  return {
    viewerEffect({ markdownBody }) {
      markdownBody.querySelectorAll('a[href]').forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });
    },
  };
}
